import React from 'react';
import PropTypes from 'prop-types';
import classNames from '../../../../utils/classNames';
import SectionTabbar from '../../../molecules/SectionTabbar';
import EditingModeBanner from '../../../molecules/EditingModeBanner';
import HomeHero from '../HomeHero';
import HomeSeekingSection from '../HomeSeekingSection';
import HomeSoundGearSection from '../HomeSoundGearSection';
import HomeCommitmentSection from '../HomeCommitmentSection';
import HomeEventsSection from '../HomeEventsSection';
import HomeBandsSection from '../HomeBandsSection';
import HomeGallerySection from '../HomeGallerySection';
import HomeMediaSection from '../HomeMediaSection';
import HomeFriendsSection from '../HomeFriendsSection';
import HomePostsSection from '../HomePostsSection';
import HomeCtaSection from '../HomeCtaSection';
import './index.scss';

export default function ProfileEditorialView({
  className,
  preContent,
  tabs = [],
  activeSection,
  onSectionChange,
  tabbarAriaLabel,
  tabbarActions,
  tabbarShowActionsOnMobile = false,
  editing = false,
  editingBanner,
  heroProps,
  seekingProps,
  soundProps,
  commitmentProps,
  eventsProps,
  bandsProps,
  galleryProps,
  mediaProps,
  friendsProps,
  postsProps,
  ctaProps,
  hiddenLocationTrigger,
}) {
  return (
    <div className={classNames('home-editorial', className)}>
      {preContent}

      {tabs.length > 0 ? (
        <SectionTabbar
          tabs={tabs}
          activeId={activeSection}
          onChange={onSectionChange}
          ariaLabel={tabbarAriaLabel}
          actions={tabbarActions}
          showActionsOnMobile={tabbarShowActionsOnMobile}
        />
      ) : null}

      {editing && editingBanner ? (
        <EditingModeBanner
          message={editingBanner.message}
          hint={editingBanner.hint}
          doneLabel={editingBanner.doneLabel}
          onDone={editingBanner.onDone}
        />
      ) : null}

      <main className="home-editorial__main">
        {heroProps ? <HomeHero {...heroProps} /> : null}
        {seekingProps ? <HomeSeekingSection {...seekingProps} /> : null}
        {soundProps ? <HomeSoundGearSection {...soundProps} /> : null}
        {commitmentProps ? <HomeCommitmentSection {...commitmentProps} /> : null}
        {eventsProps ? <HomeEventsSection {...eventsProps} /> : null}
        {bandsProps ? <HomeBandsSection {...bandsProps} /> : null}
        {galleryProps ? <HomeGallerySection {...galleryProps} /> : null}
        {mediaProps ? <HomeMediaSection {...mediaProps} /> : null}
        {postsProps ? <HomePostsSection {...postsProps} /> : null}
        {friendsProps ? <HomeFriendsSection {...friendsProps} /> : null}
        {ctaProps ? <HomeCtaSection {...ctaProps} /> : null}
      </main>

      {hiddenLocationTrigger ? (
        <button
          type="button"
          className="home-editorial__sr-only"
          onClick={hiddenLocationTrigger}
          aria-hidden="true"
          tabIndex={-1}
        />
      ) : null}
    </div>
  );
}

ProfileEditorialView.propTypes = {
  className: PropTypes.string,
  preContent: PropTypes.node,
  tabs: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string.isRequired,
    label: PropTypes.node.isRequired,
  })),
  activeSection: PropTypes.string,
  onSectionChange: PropTypes.func,
  tabbarAriaLabel: PropTypes.string,
  tabbarActions: PropTypes.node,
  tabbarShowActionsOnMobile: PropTypes.bool,
  editing: PropTypes.bool,
  editingBanner: PropTypes.shape({
    message: PropTypes.node,
    hint: PropTypes.node,
    doneLabel: PropTypes.node,
    onDone: PropTypes.func,
  }),
  heroProps: PropTypes.object,
  seekingProps: PropTypes.object,
  soundProps: PropTypes.object,
  commitmentProps: PropTypes.object,
  eventsProps: PropTypes.object,
  bandsProps: PropTypes.object,
  galleryProps: PropTypes.object,
  mediaProps: PropTypes.object,
  friendsProps: PropTypes.object,
  postsProps: PropTypes.object,
  ctaProps: PropTypes.object,
  hiddenLocationTrigger: PropTypes.func,
};
